// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "1.0.0/" + chunkId + ".index-403ca06.js";
};